/* models/tickers/single_interval_ticker */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var continuous_ticker_1 = require(228) /* ./continuous_ticker */;
    var p = require(18) /* ../../core/properties */;
    var SingleIntervalTicker = /** @class */ (function (_super) {
        tslib_1.__extends(SingleIntervalTicker, _super);
        function SingleIntervalTicker(attrs) {
            return _super.call(this, attrs) || this;
        }
        SingleIntervalTicker.initClass = function () {
            this.define({
                interval: [p.Number],
            });
        };
        SingleIntervalTicker.prototype.get_interval = function (_data_low, _data_high, _n_desired_ticks) {
            return this.interval;
        };
        Object.defineProperty(SingleIntervalTicker.prototype, "min_interval", {
            get: function () {
                return this.interval;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SingleIntervalTicker.prototype, "max_interval", {
            get: function () {
                return this.interval;
            },
            enumerable: true,
            configurable: true
        });
        SingleIntervalTicker.__name__ = "SingleIntervalTicker";
        return SingleIntervalTicker;
    }(continuous_ticker_1.ContinuousTicker));
    exports.SingleIntervalTicker = SingleIntervalTicker;
    SingleIntervalTicker.initClass();
}
